import axios from "axios";

export function loadAttendee(urlParams: string) {
  return axios({
    method: "GET",
    url: "/api/Attendee/registration/" + urlParams
  });
}

export function loadCurrentUser() {
  return axios({
    method: "GET",
    url: "/api/Attendee/current-user"
  });
}

export function saveAttendee(attendeeRecord: object) {
  return axios({
    method: "POST",
    url: "/api/Attendee",
    data: JSON.stringify(attendeeRecord),
    headers: {
      "Content-Type": "application/json"
    }
  });
}

export function loadAttendeeByAttendeeId(attendeeId:number){
   return axios({
    method: "GET",
    url: "/api/Attendee/attendee/" + attendeeId
  });
}
